import { AccordionDetails, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField } from '@mui/material';
import React from 'react';

const BiologicalSampling: React.FunctionComponent<any> = ({ handleCheck, isDisable, validationObj, disable }) => {
  return (
    <AccordionDetails className="sq-checklist-tab">
      <Grid container className="checklist-radio-actions">
        <Grid md={12}>
          <Grid container mt={1} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={7}>
              Have all biologic samples for optional study processes been collected in compliance with the protocol?{' '}
            </Grid>
            <Grid item md={2}>
              <FormControl sx={{ display: 'flex', width: '140px' }}>
                <RadioGroup
                  sx={{ justifyContent: 'flex-end' }}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="stdy_imvrp_bio_collect"
                  value={validationObj.stdy_imvrp_bio_collect}
                  onChange={e => handleCheck(e, 'section9')}
                >
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_bio_collect == 'Y' ? true : false}
                    value="Y"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_bio_collect == 'N' ? true : false}
                    value="N"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={3} sx={{ mt: -1.75 }}>
              <TextField
                name="stdy_imvrp_bio_collect_comm"
                label="Notes"
                variant="standard"
                value={validationObj.stdy_imvrp_bio_collect_comm}
                sx={{ mt: 0 }}
                onChange={e => handleCheck(e, 'section9')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 2000 }}
                InputLabelProps={{ shrink: validationObj.stdy_imvrp_bio_collect_comm }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid md={12}>
          <Grid container mt={1} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={7}>
              Are biological samples being stored, handled and shipped as per requirements?{' '}
            </Grid>
            <Grid item md={2}>
              <FormControl sx={{ display: 'flex', width: '140px' }}>
                <RadioGroup
                  sx={{ justifyContent: 'flex-end' }}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="stdy_imvrp_bio_handling"
                  value={validationObj.stdy_imvrp_bio_handling}
                  onChange={e => handleCheck(e, 'section9')}
                >
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_bio_handling == 'Y' ? true : false}
                    value="Y"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_bio_handling == 'N' ? true : false}
                    value="N"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={3} sx={{ mt: -1.75 }}>
              <TextField
                name="stdy_imvrp_bio_handling_comm"
                label="Notes"
                variant="standard"
                value={validationObj.stdy_imvrp_bio_handling_comm}
                sx={{ mt: 0 }}
                onChange={e => handleCheck(e, 'section9')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 2000 }}
                InputLabelProps={{ shrink: validationObj.stdy_imvrp_bio_handling_comm }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AccordionDetails>
  );
};

export default BiologicalSampling;
